import React, { useState, useEffect } from "react";

import { Row, Col, Form } from "react-bootstrap";
import { observer } from "mobx-react";

import { BottomsheetDropdown, ChangeProductSection } from "components";
import DeathCoverGraphSlider from "../../death-cover-graph-slider/DeathCoverGraphSlider";
import Utils from "./utils";
import AdditionalRiderBenifitsCard from "components/ui/additional-rider-benifits-card/AdditionalRiderBenifitsCard";
import fetchIncomeLabelBasedOnNeed from "utils/fetchIncomeLabelBasedOnNeed";
import DeathBenefitAmount from "utils/optimization/deathBenefitAmount";
import ProductConstants from "constants/ProductConstants";
import AdditionalCards from "./components/additional-cards/AdditionalCards";
import CompareProductModal from "components/ui/compare-products-modal/CompareProductsModal";
import ComapreQuotesTable from "components/ui/compare-quotes-table/ComapreQuotesTable";
import StorageKeys from "constants/StorageKeys";
import IsExistingCustomerModalForFDP from "./components/additional-cards/IsExistingCustomerModalForFDP";
const PremiumGuaranteedStarPro = ({ form, data }) => {
  const [showOverlay, setShowOverlay] = useState(false);

  let productData = data?.data?.BI.find(
    (item) => item.risk === data?.data?.risk
  );
  let biResponse = productData.parsedResponse;
  let firstYearResponse = productData.firstYearResponse;
  let biRequest = productData.bi_request;
  let coverLabelBaseOnNeed = fetchIncomeLabelBasedOnNeed(data.cardKey);
  let tabs = data.data.BI;
  let updatedValues;
  tabs.length > 0 &&
    tabs.map((tab) => {
      if (tab.risk === data.selectedTab) {
        updatedValues = tab.updatedValues ? tab.updatedValues : null;
      }
    });

  useEffect(() => {
    setShowOverlay(productData.fieldChanged);
  }, [productData.fieldChanged]);

  const onHideOverlay = () => {
    setShowOverlay(false);
  };

  const handleFunction = (value) => {
    form.$("is-existing-customer")?.extra?.toggleIsExistingCustomerModal(form, false)
    if (value) {
      form.$("is-existing-customer")?.set("value", { label: 'Yes', id: 1 })
    }
  }

  return (
    <div className="save-my-children">
      <Row className="align-items-center mt-4">
        <Col xs={12} md={12} className="mt-3 mt-md-0">
          <ChangeProductSection
            productName={productData.product_name || "Premier Guaranteed STAR"}
            cardName={coverLabelBaseOnNeed}
            changeProductList={data?.data?.changeProductList}
            productData={data}
            form={form}
          />
        </Col>

      </Row>

      <Row>
        <Col md={12}>
          <ComapreQuotesTable
            form={form}
            ptList={Utils.ptAllList()}
            pptList={form.$("PPT").extra.optionList}
            ptValueId={form.$("PT").value}
            ptName={"PT"}
            pptName={"PPT"}
            productData={data}
            cardKey={data.cardKey}
          />
        </Col>
      </Row>

      <DeathCoverGraphSlider
        productTitle="PGS"
        openChangeReasonModal={false}
        onIncomeChange={() => { }}
        onPremiumChange={form.$("premium").onChange}
        productID={productData.product_id}
        productData={data?.data}
        income_value=""
        premium_value={form.$("premium").value}
        showOverlay={showOverlay}
        hideOverLay={onHideOverlay}
        onClick={() =>
          form
            .$("premium")
            .extra.calculatePremiun(form, productData.product_id, data)
        }
        data=""
        cardKey={data.cardKey}
        isIncomeFieldDisable={form.$("premium").disabled}
        premiumFreq={form.$("payment-frequency").value.label}
        formRef={form}
      />
      <Row className="mt-3 ml-0">
        <p className="graph-label mb-2 font-size-12 font-size-md-14 font-weight-bold">
          {"Sum Assured on Death (at inception of the policy):"}
        </p>
        <p className="graph-label pl-1 font-size-12 font-size-md-14 font-weight-bold">
          {DeathBenefitAmount(productData)}
        </p>
      </Row>

      <Row className="mt-2 mt-md-4">
        <Col md={4} className="col-12 mb-3">
          <div className="mb-2 text-description-text-color font-size-12 font-weight-light">
            {form.$("PT").label}
          </div>
          <BottomsheetDropdown
            dropdownStyle="font-size-lg-12 font-size-14 font-weight-light"
            menuItemFontStyle="font-size-lg-12 font-size-14 font-weight-light"
            menuItemStyle="d-flex justify-content-between align-items-center"
            selectedLabelKey="label"
            bottomsheetTitle={form.$("PT").label}
            menuList={form.$("PT").extra.optionList}
            value={form.$("PT").value}
            onSelect={form.$("PT").onChange}
            disabled={form.$("PT").disabled}
          />
        </Col>
        <Col md={4} className="col-12 mb-3">
          <div className="mb-2 text-description-text-color font-size-12 font-weight-light">
            {form.$("PPT").label}
          </div>
          <BottomsheetDropdown
            dropdownStyle="font-size-lg-12 font-size-14 font-weight-light"
            menuItemFontStyle="font-size-lg-12 font-size-14 font-weight-light"
            menuItemStyle="d-flex justify-content-between align-items-center"
            selectedLabelKey="label"
            bottomsheetTitle={form.$("PPT").label}
            menuList={form.$("PPT").extra.optionList}
            value={form.$("PPT").value}
            onSelect={form.$("PPT").onChange}
            disabled={form.$("PPT").disabled}
          />
        </Col>

        <Col md={4} className="col-12 mb-3">
          <div className="mb-2 text-description-text-color font-size-12 font-weight-light">
            {form.$("payment-frequency").label}
          </div>
          <BottomsheetDropdown
            dropdownStyle="font-size-lg-12 font-size-14 font-weight-light"
            menuItemFontStyle="font-size-lg-12 font-size-14 font-weight-light"
            menuItemStyle="d-flex justify-content-between align-items-center"
            selectedLabelKey="label"
            bottomsheetTitle={form.$("payment-frequency").label}
            menuList={form.$("payment-frequency").extra.optionList}
            value={form.$("payment-frequency").value}
            onSelect={form.$("payment-frequency").onChange}
            disabled={form.$("payment-frequency").disabled}
          />
        </Col>

        <Col md={4} className="col-12 mb-3">
          <div className="mb-2 text-description-text-color font-size-12 font-weight-light">
            {form.$("ecs-mandate-auto-debit").label}
          </div>
          <BottomsheetDropdown
            dropdownStyle="font-size-lg-12 font-size-14 font-weight-light"
            menuItemFontStyle="font-size-lg-12 font-size-14 font-weight-light"
            menuItemStyle="d-flex justify-content-between align-items-center"
            selectedLabelKey="label"
            bottomsheetTitle={form.$("ecs-mandate-auto-debit").label}
            menuList={form.$("ecs-mandate-auto-debit").extra.optionList}
            value={form.$("ecs-mandate-auto-debit").value}
            onSelect={form.$("ecs-mandate-auto-debit").onChange}
            disabled={form.$("ecs-mandate-auto-debit").disabled}
          />
        </Col>
        <Col md={4} className='mb-3'>
          <p className='mb-2 font-size-12 font-weight-light '>{form.$("is-existing-customer").label}</p>
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey='label'
            bottomsheetTitle={form.$("is-existing-customer").label}
            menuList={form.$("is-existing-customer").extra.optionList}
            value={form.$("is-existing-customer").value}
            onSelect={(value) => {
              form.$("is-existing-customer").onChange(value)
              if (Number(value.id) === 1) {
                form.$("is-existing-customer")?.extra?.toggleIsExistingCustomerModal(form, true)
                form.$("is-existing-customer").set("value", { label: 'No', id: 2 })
              }
            }}
            disabled={Number(form?.$("is-existing-customer")?.value?.id) === 1 ? true : false}
          />
        </Col>

        <Col md={4} className="col-12 mb-3">
          <div className="mb-2 text-description-text-color font-size-12 font-weight-light">
            {form.$("plan-option").label}
          </div>
          <BottomsheetDropdown
            dropdownStyle="font-size-lg-12 font-size-14 font-weight-light"
            menuItemFontStyle="font-size-lg-12 font-size-14 font-weight-light"
            menuItemStyle="d-flex justify-content-between align-items-center"
            selectedLabelKey="label"
            bottomsheetTitle={form.$("plan-option").label}
            menuList={form.$("plan-option").extra.optionList}
            value={form.$("plan-option").value}
            onSelect={form.$("plan-option").onChange}
            disabled={form.$("plan-option").disabled}
          />
        </Col>

        <Col md={4} className="col-12 mb-3">
          <div className="mb-2 text-description-text-color font-size-12 font-weight-light">
            {form.$("death-benefit-option").label}
          </div>
          <BottomsheetDropdown
            dropdownStyle="font-size-lg-12 font-size-14 font-weight-light"
            menuItemFontStyle="font-size-lg-12 font-size-14 font-weight-light"
            menuItemStyle="d-flex justify-content-between align-items-center"
            selectedLabelKey="label"
            bottomsheetTitle={form.$("death-benefit-option").label}
            menuList={form.$("death-benefit-option").extra.optionList}
            value={form.$("death-benefit-option").value}
            onSelect={form.$("death-benefit-option").onChange}
            disabled={form.$("death-benefit-option").disabled}
          />
        </Col>


        <Col md={4} className="col-12 mb-3">
          <div className="mb-2 text-description-text-color font-size-12 font-weight-light">
            {form.$("income-benefit-payout-start-year").label}
          </div>
          <BottomsheetDropdown
            dropdownStyle="font-size-lg-12 font-size-14 font-weight-light"
            menuItemFontStyle="font-size-lg-12 font-size-14 font-weight-light"
            menuItemStyle="d-flex justify-content-between align-items-center"
            selectedLabelKey="label"
            bottomsheetTitle={form.$("income-benefit-payout-start-year").label}
            menuList={
              form.$("income-benefit-payout-start-year").extra.optionList
            }
            value={form.$("income-benefit-payout-start-year").value}
            onSelect={form.$("income-benefit-payout-start-year").onChange}
            disabled={form.$("income-benefit-payout-start-year").disabled}
          />
        </Col>

        <Col md={4} className="col-12 mb-3">
          <div className="mb-2 text-description-text-color font-size-12 font-weight-light">
            {form.$("income-benefit-pay-out-frequency").label}
          </div>
          <BottomsheetDropdown
            dropdownStyle="font-size-lg-12 font-size-14 font-weight-light"
            menuItemFontStyle="font-size-lg-12 font-size-14 font-weight-light"
            menuItemStyle="d-flex justify-content-between align-items-center"
            selectedLabelKey="label"
            bottomsheetTitle={form.$("income-benefit-pay-out-frequency").label}
            menuList={form.$("income-benefit-pay-out-frequency").extra.optionList}
            value={form.$("income-benefit-pay-out-frequency").value}
            onSelect={form.$("income-benefit-pay-out-frequency").onChange}
            disabled={form.$("income-benefit-pay-out-frequency").disabled}
          />
        </Col>


        <Col md={4} className="col-12 mb-3">
          <div className="mb-2 text-description-text-color font-size-12 font-weight-light">
            {form.$("income-duration").label}
          </div>
          <BottomsheetDropdown
            dropdownStyle="font-size-lg-12 font-size-14 font-weight-light"
            menuItemFontStyle="font-size-lg-12 font-size-14 font-weight-light"
            menuItemStyle="d-flex justify-content-between align-items-center"
            selectedLabelKey="label"
            bottomsheetTitle={form.$("income-duration").label}
            menuList={form.$("income-duration").extra.optionList}
            value={form.$("income-duration").value}
            onSelect={form.$("income-duration").onChange}
            disabled={form.$("income-duration").disabled}
          />
        </Col>

        <Col md={4} className="col-12 mb-3">
          <div className="mb-2 text-description-text-color font-size-12 font-weight-light">
            {form.$("sub-channel").label}
          </div>
          <BottomsheetDropdown
            dropdownStyle="font-size-lg-12 font-size-14 font-weight-light"
            menuItemFontStyle="font-size-lg-12 font-size-14 font-weight-light"
            menuItemStyle="d-flex justify-content-between align-items-center"
            selectedLabelKey="label"
            bottomsheetTitle={form.$("sub-channel").label}
            menuList={form.$("sub-channel")?.extra?.optionList}
            value={form.$("sub-channel")?.value}
            onSelect={form.$("sub-channel").onChange}
            disabled={form.$("sub-channel").disabled}
          />
        </Col>
      </Row>
      <Row className="mt-4">
        <Col md={6} className="col-12 my-4 ">
          <AdditionalRiderBenifitsCard
            data={data}
            form={form}
            showCriticalIllness={true}
            showIncomeBenefit={false}
            showHospitalityCashBenefit={true}
            showWOP={true}
            showPWB={true}
          />
        </Col>
        {/* <Col md={6} className='col-12 my-4 '>
                    <AdditionalRiderBenifitsCard
                        data={data}
                        form={form}
                        showCriticalIllness={true}
                        showIncomeBenefit={false}
                        showHospitalityCashBenefit={true}
                        showWOP={true}
                        showPWB={true}
                    />
                </Col> */}
      </Row>
      {form.$("is-existing-customer").extra.showExistingCustomerModal &&
        <IsExistingCustomerModalForFDP
          formRef={form}
          productData={productData}
          show={form.$("is-existing-customer").extra.showExistingCustomerModal}
          onHide={handleFunction}
        />
      }
    </div>
  );
};

export default observer(PremiumGuaranteedStarPro);
